
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_qk1j1_1g0v4_9",
  "textarea": "awsui_textarea_qk1j1_1g0v4_13",
  "textarea-resize-both": "awsui_textarea-resize-both_qk1j1_1g0v4_64",
  "textarea-resize-horizontal": "awsui_textarea-resize-horizontal_qk1j1_1g0v4_67",
  "textarea-resize-vertical": "awsui_textarea-resize-vertical_qk1j1_1g0v4_70",
  "textarea-resize-none": "awsui_textarea-resize-none_qk1j1_1g0v4_73",
  "textarea-readonly": "awsui_textarea-readonly_qk1j1_1g0v4_82",
  "textarea-invalid": "awsui_textarea-invalid_qk1j1_1g0v4_121",
  "textarea-warning": "awsui_textarea-warning_qk1j1_1g0v4_130"
};
  